export var space = [// margin and padding
'0px', // 0
'4px', // 1
'8px', // 2
'12px', // 3
'16px', // 4; 1.5 line height
'20px', // 5
'24px', // 6
'28px', // 7
'32px', // 8
'36px', // 9
'64px'];
var spaceToMarginMap = {
  none: '0px',
  tiny: '2px',
  xxSmall: '4px',
  xSmall: '8px',
  small: '12px',
  medium: '16px',
  large: '20px',
  xLarge: '24px',
  xxLarge: '28px'
};
Object.keys(spaceToMarginMap).forEach(function (spaceName) {
  space[spaceName] = spaceToMarginMap[spaceName];
});
export default space;